(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('kendo.core.js')) :
    typeof define === 'function' && define.amd ? define(['exports', 'kendo.core'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory((global.kendo = global.kendo || {}, global.kendo._globals = global.kendo._globals || {}, global.kendo._globals.ValueMapperChunk = {})));
})(this, (function (exports) {
    const __meta__ = {
        id: "valueMapper.chunk",
        name: "ValueMapperChunk",
        category: "web",
        description: "A reusable outputed chunk of code",
        depends: ['core'],
        hidden: true,
        chunk: true,
        
    };



    let $ = kendo.jQuery;

    function valueMapperOptions(options, value, callback) {
        return {
            value: (options.selectable === "multiple" || options.checkboxes) ? value : value[0],
            success: function(response) {
                callback(response);
            }
        };
    }

    exports.__meta__ = __meta__;
    exports.v = valueMapperOptions;

}));
